import { Calendar } from 'views/CheckoutPage/components/Calendar';
import {
  calculateReturnRangeStartDate,
  calculateReturnRangeEndDate,
  isValidReturnDate
} from 'views/CheckoutPage/components/utils';
import { rm } from 'utils';
import { ToolTip } from 'components/Shared/ToolTip';
import { Props } from './rentalPeriod';
import styles from './rentalPeriod.scss';
import cn from 'classnames';

const EndDateTitle = (): JSX.Element => (
  <>
    {rm('checkout_calendar_to')} <ToolTip text={rm('checkout_calendar_to_rental_tooltip')} />
  </>
);

export interface EndProps
  extends Pick<
    Props,
    | 'setReturnDate'
    | 'selectedReturnDate'
    | 'dispatchRentalPeriod'
    | 'selectedPickupDate'
    | 'shouldBeDisabled'
  > {
  toggleShowPickupDateSelector: (showPickSelector: boolean) => void;
  toggleShowReturnDateSelector: (showPickSelector: boolean) => void;
  defaultReturnStartDate: Date;
  showReturnDateSelector: boolean;
}
export const EndCalendar = ({
  setReturnDate,
  toggleShowPickupDateSelector,
  toggleShowReturnDateSelector,
  defaultReturnStartDate,
  selectedReturnDate,
  dispatchRentalPeriod,
  selectedPickupDate,
  shouldBeDisabled,
  showReturnDateSelector
}: EndProps): JSX.Element => {
  const returnRangeStartDate = calculateReturnRangeStartDate(
    selectedPickupDate,
    defaultReturnStartDate
  );

  const returnRangeEndDate = calculateReturnRangeEndDate(
    selectedPickupDate,
    defaultReturnStartDate
  );

  const handleReturnDateToggle = () => {
    toggleShowReturnDateSelector(!showReturnDateSelector);
    toggleShowPickupDateSelector(false);
  };

  const onSelectingReturnDate = (selectedDate: Date) => {
    setReturnDate(selectedDate);

    const newReturnRangeStartDate = calculateReturnRangeStartDate(
      selectedPickupDate,
      defaultReturnStartDate
    );
    const newReturnRangeEndDate = calculateReturnRangeEndDate(
      selectedPickupDate,
      defaultReturnStartDate
    );
    const hasReturnDate =
      selectedPickupDate &&
      isValidReturnDate({
        compareDate: selectedPickupDate,
        selectedDate,
        returnRangeStartDate: newReturnRangeStartDate,
        returnRangeEndDate: newReturnRangeEndDate
      });

    hasReturnDate ? dispatchRentalPeriod() : toggleShowPickupDateSelector(true);
    toggleShowReturnDateSelector(false);
  };

  return (
    <div className={cn(styles.contentWrapper, styles.right)}>
      <Calendar
        onDateChange={onSelectingReturnDate}
        rangeStartDate={returnRangeStartDate}
        rangeEndDate={returnRangeEndDate}
        title={<EndDateTitle />}
        selectedDate={selectedReturnDate}
        showDateSelector={showReturnDateSelector}
        toggleDateSelector={handleReturnDateToggle}
        shouldBeDisabled={shouldBeDisabled}
        browseCalendar
      />
    </div>
  );
};
